import { render, staticRenderFns } from "./Page-5.vue?vue&type=template&id=5988340a&scoped=true&"
var script = {}
import style0 from "./Page-5.vue?vue&type=style&index=0&id=5988340a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5988340a",
  null
  
)

export default component.exports